import axios, { AxiosError } from "axios"
import {
  requestInterceptorErrorSecurityCredentials,
  requestInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
  responseInterceptorSuccessCredentials,
} from "interceptors"
import { HISTORY_TYPE_PATH, LIST_PATH } from "../../constants/paths"

const instance = axios.create({
  baseURL: process.env.REACT_APP_DOCUMENTS_API_SERVICE_DOMAIN,
})

instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getHistoryTypesService = async () => {
  try {
    const result = await instance.get(HISTORY_TYPE_PATH + LIST_PATH)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
